const Check = props => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="#509E2F" {...props}>
    <g mask="url(#mask0_2185_26285)">
      <path d="M6.36641 12.0001L2.56641 8.20007L3.51641 7.25007L6.36641 10.1001L12.4831 3.9834L13.4331 4.9334L6.36641 12.0001Z" />
    </g>
  </svg>
);

export default Check;
